import { useRef } from "react";

const Avatar = ({ item, image }) => {
  const avatarColors = [
    "#F4FFAA",
    "#C65C61",
    "#897CAC",
    "#A8C2D7",
    "#BC7B65",
    "#E2B5B2",
    "#9A8D8E",
    "#A7570C",
    "#A27B88",
    "#718392",
  ];

  const colorRef = useRef(
    avatarColors[Math.floor(Math.random() * avatarColors.length)],
  );

  return (
    <div
      className="chat-users-item__avatar"
      style={{ backgroundColor: colorRef.current }}
    >
      {image ? <img width={50} alt={"avatar"} src={image} /> : item.charAt(0)}
    </div>
  );
};

export default Avatar;
